// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1Dnvu","file":"styles_file__vxUsp"};